<template>
  <section class="scrollable">
    <div class="container quote-list">
      <div class="row quote-row no-gutters">
        <div
          v-for="(quote, i) in quotes"
          :key="`q-${i}`"
          class="col-12 col-md-6 col-quote"
          :class="{
            'col-lg-4': i < 3,
            'col-lg-6': i >= 3
          }"
        >
          <blockquote>
            <p>
              {{ quote.text }}
            </p>
            <small>
              {{ quote.author }}
            </small>
          </blockquote>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Testimonials",
  data() {
    return {
      activeCol: 0,
      quotes: [
        {
          text:
            "I've been working with Vitalli for over 2 years and he's the best developer I've worked with. No exaggeration. You can count on Vitalii to take the right technical decisions when it comes to solving difficult problems and challenges, even when there's limited amounts of information available on the table.",
          author: "Lubomir Fotev, Parrity"
        },
        {
          text:
            "Phenomenal developer and extremely patient and takes the time to properly understand business requirements. Vitalii is very talented and a pleasure to work with.",
          author: "Mog Obahor, 2dots properties"
        },
        {
          text:
            "Vitalii and I worked together to build a CMS-style app, and I was highly impressed with his technical skill, far-ranging knowledge of web application architecture and willingness to tackle any task. He has a great work ethic and is an excellent communicator. I recommend him highly, and look forward to the next time we collaborate!",
          author: "Nate Eckerson, MaxLiving"
        },
        {
          text:
            "I have been working with Vitaliy on the big platform. He always gives extremely useful code review and it helps folks on the team level up. He moves beyond existing applications and comes up with new applications that improve operations. Demonstrates willingness to follow and learn the latest trends in programming. And he always helps to improve CI/CD processes inside the entire team.",
          author: "Volodymyr Nazarko, Intellias"
        },
        {
          text:
            "Vitalii handles hard problems well and does not shy from challenges. He is better than most devs at working in existing codebases of a complex nature. He is very competent, extremely communicative, a responsible freelancer and a terrific person. He is a great addition to a team. I highly recommend him.",
          author: "Evan F. Stealth Startup"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
$total-items: 5;

section {
  background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    url("~@/assets/img/testimonials.jpg");

  .quote-list {
    max-height: 100vh;
    h2 {
      text-align: center;
    }

    blockquote {
      &::before {
        content: "\201D";
        position: absolute;
        font-size: 10rem;
        top: 0;
        left: -0.4rem;
        color: #4b95d761;
        font-style: italic;
        z-index: 0;
      }

      cursor: pointer;
      padding: 2rem 1.6rem 1rem 1.6rem;
      margin: 0.6rem;
      border-radius: 20px;
      text-align: left;
      background-color: #ffffff;
      color: #000000;

      p {
        margin: 0;
        line-height: 1.2;
        word-spacing: 1.5px;
      }

      small {
        margin-top: 0.5rem;
        cursor: pointer;
        font-style: italic;
        color: #555555;
        text-align: right;
        display: block;
        text-align: right;
        text-decoration: underline;
      }
    }
  }

  .col-quote {
    animation: fadeIn 0.5s linear;
    animation-fill-mode: both;
  }
  @for $i from 1 through $total-items {
    .col-quote:nth-child(#{$i}) {
      animation-delay: 0.25s * $i;
    }
  }
  @media (max-width: 991px) {
    .quote-row {
      padding-top: 3rem;
      padding-bottom: 3rem;
    }
  }
  @media (max-width: 595px) {
    .quote-list {
      margin-right: 11px;
    }
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    top: 100px;
  }
  75% {
    opacity: 0.5;
    top: 0px;
  }
  100% {
    opacity: 1;
  }
}
</style>
